// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"16824":"133c4b0ec1456050","25464":"c9fc87ffe2e749db","68072":"ae0411497c8b0f2a","98227":"5772277d4233d146"}[chunkId] + ".css";
};